import { RouterView } from 'vue-router'

export const locationsRoutes = [
  {
    path: '/locations',
    component: RouterView,
    meta: {
      locationTypes: ['organization', 'singleLocation']
    },
    children: [
      {
        name: 'locations',
        path: '',
        component: () => import('@/modules/locations/views/Locations.vue'),
        meta: {
          locationTypes: ['organization', 'singleLocation']
        }
      },
      {
        name: 'createLocation',
        path: 'create',
        component: () => import('@/modules/locations/views/CreateLocation.vue'),
        meta: {
          locationTypes: ['organization', 'singleLocation'],
          hideMenu: true
        }
      }
    ]
  }
]
